export default [
  {
    path: '/modules/report',
    name: 'reportPageEvent',
    component: () => import('@/views/modules/report/Report.vue'),
    meta: {
      action: 'ROLE_RELATORIO_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Relatórios',
      breadcrumb: [
        {
          text: 'Eventos',
        },
      ],
    },
    children: [
      {
        path: 'event',
        name: 'report-event',
        component: () => import('@/views/modules/report/Report.vue'),
        meta: {
          pageTitle: 'Relatórios',
          action: 'ROLE_RELATORIO_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Eventos | Relatórios',
            },
          ],
        },
      },
    ],
  },
]
